import actions from "./actions";
import mutations from "./mutations";

const state = {
  selectedVenue: null,
  queryVenue: null,
  list: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
